import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import Spinner from "../Spinner/Spinner";
import ExpiryCard from "./ExpiryCard";
import { constants } from "../../firebase/firestoreNameSpaces";

const ExpiryManagementComponent = (props) => {
  useEffect(() => {
    props.onFetchExpiredProducts();
  }, []);

  if (props.loading) {
    return <Spinner />;
  }

  const handleUpdateExpiry = (productId, variantId, expiry) => {
    props.onUpdateExpiry(productId, variantId, expiry);
  };
  const getExpiryCards = () => {
    let cards = [];
    let expiredProducts = props.expiredProducts;
    if (expiredProducts) {
      expiredProducts.map((pObj) => {
        cards.push(
          <ExpiryCard
            product={pObj}
            updateExpiry={(expiry) =>
              handleUpdateExpiry(pObj.id, pObj.variantId, expiry)
            }
            updateBtnLoading={props.updateBtnLoading}
          />
        );
      });
    }
    return cards;
  };

  return (
    <div className="container mt-4" style={{ width: "70%" }}>
      <h6 className="text-center">{`The Products having Expiry in ${constants.EXPIRY_THRESHOLD} Days is shown`}</h6>
      <div className="text-center mt-3 mb-3">
        {props.expiredProducts && (
          <h2>
            {props.expiredProducts.length
              ? "Expired Products"
              : "Hurray! No Products are Expired"}
          </h2>
        )}
      </div>
      {getExpiryCards()}
      {/* <h1>{props.stockOutProducts?props.stockOutProducts[0].productTitle:"No product"}</h1> */}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.stock.loading,
    updateBtnLoading: state.stock.updateBtnLoading,
    expiredProducts: state.stock.expiredProducts,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchExpiredProducts: () => dispatch(actions.fetchExpiredProducts()),
    onUpdateExpiry: (productId, variantId, expiry) =>
      dispatch(actions.updateExpiry(productId, variantId, expiry)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExpiryManagementComponent);
